import { render, staticRenderFns } from "./bianminfenlei.vue?vue&type=template&id=f3764a4c&scoped=true"
import script from "./bianminfenlei.vue?vue&type=script&lang=js"
export * from "./bianminfenlei.vue?vue&type=script&lang=js"
import style0 from "./bianminfenlei.vue?vue&type=style&index=0&id=f3764a4c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3764a4c",
  null
  
)

export default component.exports